import{toFinite as o}from"./toFinite.js";function i(e){const t=o(e),n=t%1;return n?t-n:t}export{i as toInteger};
